import { FieldError } from "react-hook-form";

interface Props {
	error?: FieldError;
}
export default function ValidateError(props: Props) {
	if (!props.error) return null;

	return <p className="mt-2.5 verify-text">{props.error.message}</p>;
}
